//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VideoLibraryDashboard from "./videoLibraryDashboard.vue";
import Item from "./Item.vue";
import { format } from "date-fns";

export default {
    name: "VideoLibraryResults",
    components: { Item, VideoLibraryDashboard },
    props: ['searchSubmitted', 'hasFilters', 'activeFilters'],
    data() {
        return {
        };
    },
    computed: {
        results() {
            return this.$store.getters.results.itemResults;
        },
        dashboardData() {
            return this.$store.getters.results.dashboardData
        },
        reloading() {
            if (this.options.transitionOnReload) return this.$store.getters.reloading;
            else return false
        },
        showIndividual() {
            const onlyCategoryFilter = this.hasFilters && this.activeFilters && this.activeFilters.categories?.length && !this.activeFilters.levels?.length && !this.activeFilters.types?.length;
            return this.searchSubmitted || (this.hasFilters && !onlyCategoryFilter);
        },
        // non-bluesearch
        resultsByCategory() {
            return this.results.reduce((acc, result) => {
                result.meta.videocategories.forEach(category => {
                    if (!acc[category.name]) {
                        acc[category.name] = []
                    }
                    acc[category.name].push(result)
                })
                return acc
            }, {})
        },
        resultsByCategoryKeys() {
            return Object.keys(this.resultsByCategory)
        }
    },
    methods: {
        formatDate(date, formatPattern) {
            return format(new Date(date), formatPattern);
        },
        getElTop() {
            let elem = this.$root.$el;
            let distance = 0;
            do {
            distance += elem.offsetTop;
            elem = elem.offsetParent;
            } while (elem);
            distance = distance < 0 ? 0 : distance;
            return distance;
        },
        scrollToTop() {
            if (this.options.scrollOnReload) window.scrollTo({ top: this.getElTop(), behavior: "smooth" });
        },
        // non-bluesearch
    },
    watch: {
        reloading() {
            this.scrollToTop();
        },
    },
    mounted() {
        // this.getVideoCategories()
        // this.initSwiper()
    }
};
